import { motion } from "framer-motion";
import { MapPin, Truck, CurrencyEur, Phone } from "@phosphor-icons/react";

export default function ZoneSection() {
  return (
    <section className="py-20 bokeh-section" data-testid="zone-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl sm:text-4xl font-extrabold text-white mb-4">
            Zone de <span className="gradient-text">Livraison</span>
          </h2>
          <p className="text-[#B8A88A] max-w-2xl mx-auto">
            Nous intervenons sur le Nord Isère et l'Est Lyonnais. Livraison incluse jusqu'à 20 km.
          </p>
        </motion.div>
        
        {/* Delivery info badge */}
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          className="glass rounded-2xl p-6 mb-12 max-w-3xl mx-auto border border-[#C9A962]/30"
        >
          <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-full bg-gradient-to-br from-[#C9A962] to-[#A88B4A] flex items-center justify-center">
                <Truck size={24} weight="fill" className="text-black" />
              </div>
              <div>
                <p className="text-white font-semibold">Livraison incluse</p>
                <p className="text-[#B8A88A] text-sm">jusqu'à 20 km</p>
              </div>
            </div>
            
            <div className="hidden sm:block w-px h-12 bg-[#C9A962]/30" />
            
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-full bg-[#0A0A0A] border border-[#C9A962]/30 flex items-center justify-center">
                <CurrencyEur size={24} className="text-[#C9A962]" />
              </div>
              <div>
                <p className="text-white font-semibold">0,50€/km</p>
                <p className="text-[#B8A88A] text-sm">au-delà (x4 trajets)</p>
              </div>
            </div>
          </div>
        </motion.div>
        
        {/* Single zone card */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="max-w-2xl mx-auto"
          data-testid="zone-card"
        >
          <div className="bg-gradient-to-br from-[#C9A962]/10 to-transparent border border-[#C9A962]/30 rounded-2xl p-8 text-center">
            <div className="w-16 h-16 rounded-full bg-gradient-to-br from-[#C9A962] to-[#A88B4A] flex items-center justify-center mx-auto mb-4">
              <MapPin size={32} weight="fill" className="text-black" />
            </div>
            
            <h3 className="text-2xl font-bold text-white mb-2">Nord Isère & Est Lyonnais</h3>
            
            <div className="text-[#B8A88A] space-y-1 mb-6">
              <p>225 avenue des marronniers</p>
              <p>38300 Bourgoin-Jallieu</p>
            </div>
            
            <a 
              href="tel:0745709881" 
              className="inline-flex items-center gap-2 text-[#C9A962] hover:text-[#D4BA7A] font-semibold transition-colors"
            >
              <Phone size={20} weight="fill" />
              07 45 70 98 81
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
